import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';

import Header from '~/Components/Header/Header';
import CardNavigationTab from '~/Components/CardNavigationTab';
import Loading from '~/Components/Loading';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { getAtivosQualidade } from '~/Services/Service';

import TabQualidade from './components/TabQualidade';
import TabDadosImovel from './components/TabDadosImovel';
import TabAnexarDoc from './components/TabAnexarDoc';
import TabParcelas from './components/TabParcelas';

const QualidadeAtivo = () => {
  const [activeTab, setActiveTab] = useState('');
  const [familia, setFamilia] = useState(null);
  const [quadra, setQuadra] = useState('');
  const [loteDe, setLoteDe] = useState('');
  const [loteAte, setLoteAte] = useState('');
  const [incluirInativos, setIncluirInativos] = useState(false);
  const [ativos, setAtivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const empreendimentos = useSelector((state) => state.empreendimentos);

  const temQualidade = AuthStorage.temCaracteristica(
    caracteristicas.AtualizaQualidade
  );
  const temDadosImovel = AuthStorage.temCaracteristica(
    caracteristicas.AtualizaAtivo
  );
  const temAnexarDoc = AuthStorage.temCaracteristica(
    caracteristicas.AtualizaDocumento
  );
  const temParcelas = AuthStorage.temCaracteristica(
    caracteristicas.AtualizaParcelas
  );

  const opcoesEmpreendimento = (empreendimentos.list || []).map((e) => ({
    value: e.codigo,
    label: e.descricao,
  }));

  const tabs = [
    temQualidade && {
      label: 'Qualidade',
      url: 'qualidade',
      component: (
        <TabQualidade
          ativos={ativos}
          familia={familia && familia.value}
          onRecarregar={handleBuscar}
        />
      ),
    },
    temDadosImovel && {
      label: 'Dados do Imóvel',
      url: 'dados-imovel',
      component: (
        <TabDadosImovel ativos={ativos} familia={familia && familia.value} />
      ),
    },
    temAnexarDoc && {
      label: 'Anexar Documento',
      url: 'anexar-doc',
      component: (
        <TabAnexarDoc
          ativos={ativos}
          familia={familia && familia.value}
          onRecarregar={handleBuscar}
        />
      ),
    },
    temParcelas && {
      label: 'Parcelas Programadas',
      url: 'parcelas',
      component: <TabParcelas ativos={ativos} familia={familia && familia.value} />,
    },
  ].filter(Boolean);

  // Set first available tab
  React.useEffect(() => {
    if (tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].url);
    }
  }, [temQualidade, temDadosImovel, temAnexarDoc, temParcelas]);

  async function handleBuscar() {
    if (!familia) {
      toast.error('Selecione um empreendimento');
      return;
    }
    setLoading(true);
    try {
      const res = await getAtivosQualidade(
        familia.value,
        quadra,
        loteDe,
        loteAte,
        incluirInativos
      );
      setAtivos(res.data || []);
    } catch {
      toast.error('Erro ao buscar ativos');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Header title="Qualidade do Ativo" />

      <Card className="mb-3">
        <Card.Body>
          <Row>
            <Col md={5}>
              <Form.Group>
                <Form.Label>Empreendimento</Form.Label>
                <Select
                  value={familia}
                  onChange={(opt) => {
                    setFamilia(opt);
                    setAtivos([]);
                  }}
                  options={opcoesEmpreendimento}
                  placeholder="Selecione..."
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  isClearable
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Quadra</Form.Label>
                <Form.Control
                  value={quadra}
                  onChange={(e) => setQuadra(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={1}>
              <Form.Group>
                <Form.Label>Lote De</Form.Label>
                <Form.Control
                  value={loteDe}
                  onChange={(e) => setLoteDe(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={1}>
              <Form.Group>
                <Form.Label>Lote Até</Form.Label>
                <Form.Control
                  value={loteAte}
                  onChange={(e) => setLoteAte(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={1} className="d-flex align-items-end">
              <Form.Check
                type="checkbox"
                label="Inativos"
                checked={incluirInativos}
                onChange={(e) => setIncluirInativos(e.target.checked)}
                className="mb-3"
              />
            </Col>
            <Col md={2} className="d-flex align-items-end">
              <Button
                variant="primary"
                className="mb-3"
                onClick={handleBuscar}
                disabled={!familia || loading}
              >
                {loading ? 'Buscando...' : 'Buscar'}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {loading && <Loading />}

      {!loading && tabs.length > 0 && ativos.length > 0 && (
        <CardNavigationTab
          activeTab={activeTab}
          onChangeTab={setActiveTab}
          tabs={tabs}
        />
      )}

      {!loading && tabs.length === 0 && (
        <p className="text-muted">
          Você não possui permissão para acessar as funcionalidades desta tela.
        </p>
      )}
    </>
  );
};

export default QualidadeAtivo;
